<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="活动ID" :value="1"></el-option>
                            <el-option label="活动名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.showStatus" placeholder="请选择" size="small">
                        <el-option label="不限制活动状态" :value="-1"></el-option>
                        <el-option label="仅看展示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.queryTimeType" slot="prepend" placeholder="请选择">
                                <el-option label="展示时间" :value="1"></el-option>
                                <!-- <el-option label="发起时间" :value="2"></el-option> -->
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/home/event/edit')" type="primary" icon="el-icon-plus" size="small" @click="add()">创建活动入口</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="活动ID"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="{row} = scope">
                        <el-tag v-if="row.showStatus == 1" type="success" size="mini">展示</el-tag>
                        <el-tag v-else type="info" size="mini">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="活动名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cityView" label="展示城市"></el-table-column>
                <el-table-column label="展示终端">
                    <template slot-scope="{row} = scope">APP</template>
                </el-table-column>
                <el-table-column label="展示时间段1" :min-width="180">
                    <template slot-scope="scope">
                        <p>从：{{`${scope.row.showStartDate || '-'}`}}</p>
                        <p>到：{{`${scope.row.showEndDate || '-'}`}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="展示时间段2" :min-width="180">
                    <template slot-scope="scope">
                        <p>从：{{`${scope.row.firstShowStartDate || '-'}`}}</p>
                        <p>到：{{`${scope.row.firstShowEndDate || '-'}`}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="展示时间段3" :min-width="180">
                    <template slot-scope="scope">
                        <p>从：{{`${scope.row.secondShowStartDate || '-'}`}}</p>
                        <p>到：{{`${scope.row.secondShowEndDate || '-'}`}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="clickNum" label="点击量"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/home/event/edit')" type="text" size="small" @click="edit(row.id)" >编辑</el-button>
                        <!-- <el-button v-if="$utils.have('/point/goods/updateStatus')" type="text" size="small" @click="updateStatus(row)" >{{ row.status == 0 ? '下架' : '上架' }}</el-button> -->
                        <!-- <el-button v-if="$utils.have('/point/goods/updateStatus')" type="text" size="small" @click="updateStatus(row, 2)" >删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    showStatus: -1,
    queryTimeType: 1,
    startTime: "",
    endTime: ""
}
export default {
    data(){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                showStatus: parseInt(this.$route.query.showStatus) || -1,
                queryTimeType:parseInt(this.$route.query.queryTimeType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
            },
            listLoading: true,
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/home/event/list",
                method: "POST",
                data: {
                    ...this.params,
                    startTime: this.datetimerange && this.datetimerange[0] || '',
                    endTime: this.datetimerange && this.datetimerange[1] || ''
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        add(){
            this.$router.push('/operation/homeEventConfig/add')
        },
        edit(id){
            this.$router.push({
                path: `/operation/homeEventConfig/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>